import clsx from "clsx";
import React, { PropsWithChildren, ReactElement } from "react";

import css from "./index.module.scss";

export type CardFooterColorType = "blue" | "green" | "red" | "yellow";

type Props = {
  className?: string;
  footer?: ReactElement;
  footerColor?: CardFooterColorType;
  title?: string;
};

const CardNew = ({
  children,
  className,
  footer,
  footerColor,
  title,
}: PropsWithChildren<Props>) => {
  return (
    <>
      <div className={css.card}>
        {title && <h4 className={css.cardTitle}>{title}</h4>}
        <div className={clsx(css.cardContent, className)}>{children}</div>
      </div>
      {footer && (
        <div className={clsx(css.footer, footerColor && css[footerColor])}>
          {footer}
        </div>
      )}
    </>
  );
};

export default CardNew;
